class AjaxStub {
  constructor(urlPattern, responseData) {
    this.urlPattern = urlPattern;
    this.responseData = responseData;
  }
}

const externalAjaxRequest = (params) => {
  const stubsByRequestType = {
    GET: [
      new AjaxStub(
        /https:\/\/picha.*\.charitywater\.org\/api\/v1\/projects_featured_photos\?ids=176-400/,
        {
          '176-400':
            'https://cw-saizi-photos-acceptance.s3.amazonaws.com/ET.RST.Q4.16.176/400/ET.RST.Q4.16.176-400-c2dadcdceddc566af6d3f0020f2ed309fac0a13e.jpg',
        }
      ),
      new AjaxStub(
        /https:\/\/picha.*\.charitywater\.org\/api\/v1\/projects_featured_photos\?ids=48-1,48-2,734-3/,
        {
          '48-1':
            'https://cw-saizi-photos-acceptance.s3.amazonaws.com/ET.RST.Q4.16.176/400/ET.RST.Q4.16.176-400-c2dadcdceddc566af6d3f0020f2ed309fac0a13e.jpg',
          '48-2':
            'https://cw-saizi-photos-acceptance.s3.amazonaws.com/ET.RST.Q4.16.176/400/ET.RST.Q4.16.176-400-c2dadcdceddc566af6d3f0020f2ed309fac0a13e.jpg',
          '734-3':
            'https://cw-saizi-photos-acceptance.s3.amazonaws.com/ET.RST.Q4.16.176/400/ET.RST.Q4.16.176-400-c2dadcdceddc566af6d3f0020f2ed309fac0a13e.jpg',
        }
      ),
      new AjaxStub(
        /https:\/\/picha.*\.charitywater\.org\/api\/v1\/projects_featured_photos\?ids=48-1/,
        {
          '48-1':
            'https://cw-saizi-photos-acceptance.s3.amazonaws.com/ET.GOH.Q4.09.048/001/ET.GOH.Q4.09.048-1-f5b5e3c8837a200f1dc4c053f68c08c32ce2fb3b.jpg',
        }
      ),
      new AjaxStub(
        /https:\/\/picha.*\.charitywater\.org\/api\/v1\/projects_featured_photos\?ids=48-282/,
        {
          '48-282':
            'https://cw-saizi-photos-acceptance.s3.amazonaws.com/ET.GOH.Q4.09.048/282/ET.GOH.Q4.09.048-282-b491aa3a7686878cc1a569fb0d8167d7989a7ecf.jpg',
        }
      ),
      new AjaxStub(
        /https:\/\/picha.*\.charitywater\.org\/api\/v1\/project_photos\/48-3/,
        []
      ),
      new AjaxStub(
        /https:\/\/picha.*\.charitywater\.org\/api\/v1\/project_photos\/317-1/,
        [
          'https://cw-saizi-photos-acceptance.s3.amazonaws.com/ML.WVI.2H.19.317/001/ML.WVI.2H.19.317-1-abd679c5f902dcaf884f8fdab4fef959a276b8d9.jpg',
          'https://cw-saizi-photos-acceptance.s3.amazonaws.com/ML.WVI.2H.19.317/001/ML.WVI.2H.19.317-1-dc245f56e71d05c19549d583eb6cb8cddc3307ee.jpg',
        ]
      ),
      new AjaxStub(
        /https:\/\/picha.*\.charitywater\.org\/api\/v1\/project_photos\/317-2/,
        [
          'https://cw-saizi-photos-acceptance.s3.amazonaws.com/ML.WVI.2H.19.317/002/ML.WVI.2H.19.317-2-893a5e853c27d05a8e84de03bf6989e9a74c56d1.jpeg',
          'https://cw-saizi-photos-acceptance.s3.amazonaws.com/ML.WVI.2H.19.317/002/ML.WVI.2H.19.317-2-ced8753e7b29006a55560322556006251e4a7391.jpg',
        ]
      ),
      new AjaxStub(
        /https:\/\/picha.*\.charitywater\.org\/api\/v1\/project_photos\/393-282/,
        [
          'https://cw-saizi-photos-acceptance.s3.amazonaws.com/ET.RST.1H.21.393/282/ET.RST.1H.21.393-282-4e06e5f964657bd055c879774c3fceae7c0288d7.jpg',
        ]
      ),
      new AjaxStub(
        /https:\/\/picha.*\.charitywater\.org\/api\/v1\/project_photos\/391-1/,
        [
          'https://cw-saizi-photos-acceptance.s3.amazonaws.com/UG.TWT.1H.21.391/001/UG.TWT.1H.21.391-1-893a5e853c27d05a8e84de03bf6989e9a74c56d1.jpeg',
          'https://cw-saizi-photos-acceptance.s3.amazonaws.com/UG.TWT.1H.21.391/001/UG.TWT.1H.21.391-1-242aac7075c3ec60a768f1d6a6674e2a1089f7ed.jpg',
        ]
      ),
      new AjaxStub(
        /https:\/\/picha.*\.charitywater\.org\/api\/v1\/project_photos\/176-405/,
        [
          'https://cw-saizi-photos-acceptance.s3.amazonaws.com/ET.RST.Q4.14.176/405/ET.RST.Q4.14.176-405-c2dadcdceddc566af6d3f0020f2ed309fac0a13e.jpg',
        ]
      ),
      new AjaxStub(
        /https:\/\/picha.*\.charitywater\.org\/api\/v1\/project_photos\/48-\d/,
        [
          'https://cw-saizi-photos-acceptance.s3.amazonaws.com/ET.GOH.Q4.09.048/001/ET.GOH.Q4.09.048-1-f5b5e3c8837a200f1dc4c053f68c08c32ce2fb3b.jpg',
          'https://cw-saizi-photos-acceptance.s3.amazonaws.com/ET.GOH.Q4.09.048/282/ET.GOH.Q4.09.048-282-b491aa3a7686878cc1a569fb0d8167d7989a7ecf.jpg',
        ]
      ),
    ],
  };

  if (!(window.railsEnv === 'test' && window.useStubbedAjaxResponses))
    return $.ajax(params);

  const matchingStubs = stubsByRequestType[params.type].filter((ajaxStub) =>
    params.url.match(ajaxStub.urlPattern)
  );
  if (matchingStubs.length > 0) {
    params.success(matchingStubs[0].responseData);
  } else {
    $.ajax(params);
  }
};

export default externalAjaxRequest;
